module.exports = __webpack_public_path__ + "static/media/pic13.836d1c9f.jpg";